import React from "react";
import { ReactComponent as InstagramIcon } from "../assets/icons/instagram.svg";
import { ReactComponent as YoutubeIcon } from "../assets/icons/youtube.svg";
import { ReactComponent as TwitterIcon } from "../assets/icons/twitter.svg";
import { ReactComponent as LinkedinIcon } from "../assets/icons/linkedin.svg";
import { ReactComponent as VIcon } from "../assets/icons/v.svg";
import { ReactComponent as MapsIcon } from "../assets/icons/maps.svg";
import { ReactComponent as EmailIcon } from "../assets/icons/email.svg";
import { ReactComponent as PhoneIcon } from "../assets/icons/phone.svg";

import ok from "../assets/footer/okayLetsGo.svg";

function Footer() {
  return (
    <div className='footer'>
      <div className='contact-wrapper'>
        <img src={ok} alt="ok let's go" />
        {/*<a className='email' href='mailto:contact@finalversion2.com'>
          contact@finalversion2.com
        </a> */}
      </div>
      <div>
      <ul>
          <li>
            <a
              href='https://www.instagram.com/finalversion2/'
              title="Check out our Instagram page"
              target='_blank'
              rel='noreferrer'>
              <InstagramIcon />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/final-version-2/"
              title="Visit us on LinkedIn"
              target="_blank"
              rel="noreferrer">
              <LinkedinIcon />
            </a>
          </li>
          {/*
          <li>
            <a 
              href="https://www.youtube.com/@AnamorphicChannel" 
              title="View the AnamorphicChannel on Youtube"
              target="_blank" 
              rel="noreferrer">
              <YoutubeIcon />
            </a>
          </li>
          */}
          <li>
            <a 
              href="https://www.google.com/maps/place/Final+Version+2+Studios+Ltd/@49.2847251,-123.0967432,17z/data=!3m2!4b1!5s0x54867173fa78f235:0xcec9ff25ccffbc17!4m6!3m5!1s0xa2948f5877a59f93:0xe4003a4c22b87da8!8m2!3d49.2847251!4d-123.0967432!16s%2Fg%2F11svw_5c34?entry=ttu&g_ep=EgoyMDI1MDYwOC4wIKXMDSoASAFQAw%3D%3D" 
              title="Find out where our office is"
              target="_blank" 
              rel="noreferrer">
              <MapsIcon />
            </a>
          </li>
          <li>
            <a 
              href="mailto:contact@finalversion2.com" 
              title="Send us an email">
              <EmailIcon />
            </a>
          </li>
          {/* <li>
            <a href="tel:+12508858191" target="_blank" rel="noreferrer">
              <PhoneIcon />
            </a>
          </li> */}
        </ul>
      </div>
      <div>
        <p className='copyright'>© 2026 Final Version 2. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;